
import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative pt-20 md:pt-24 pb-12 md:pb-20 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/0c6230f86d87113651ea974697f133e0.jpg"
          alt="DMM FX 安全性解説"
          className="w-full h-full object-cover object-top"
          loading="lazy"
          decoding="async"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-gray-900/80 via-gray-900/70 to-gray-900/50"></div>
      </div>

      <div className="relative max-w-6xl mx-auto px-4 pt-8 md:pt-12 pb-4">
        <div className="max-w-3xl">
          <div className="flex items-center space-x-2 mb-4 md:mb-6">
            <Link
              to="/"
              className="text-xs md:text-sm text-white/70 hover:text-white transition-colors cursor-pointer"
            >
              ホーム
            </Link>
            <i className="ri-arrow-right-s-line text-white/50 w-4 h-4 flex items-center justify-center"></i>
            <span className="text-xs md:text-sm text-teal-300">安全性を徹底解説</span>
          </div>

          <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4 md:mb-6 leading-tight">
            DMM FXは危険？<br />
            <span className="text-teal-300">安全性を徹底解説</span>
          </h1>

          <p className="text-sm md:text-lg text-white/80 leading-relaxed mb-6 md:mb-8 max-w-2xl">
            「FXは危険」「DMM FXは大丈夫？」そんな不安を持つ初心者の方へ。金融庁登録・信託保全・セキュリティ対策など、あらゆる角度からDMM FXの安全性をやさしく解説します。
          </p>

          <div className="flex flex-wrap gap-2 md:gap-3">
            <span className="inline-flex items-center bg-white/15 backdrop-blur-sm text-white text-xs md:text-sm px-3 md:px-4 py-1.5 md:py-2 rounded-full">
              <i className="ri-shield-check-line text-teal-300 mr-1.5 md:mr-2 w-4 h-4 flex items-center justify-center"></i>
              金融庁登録済み
            </span>
            <span className="inline-flex items-center bg-white/15 backdrop-blur-sm text-white text-xs md:text-sm px-3 md:px-4 py-1.5 md:py-2 rounded-full">
              <i className="ri-safe-line text-teal-300 mr-1.5 md:mr-2 w-4 h-4 flex items-center justify-center"></i>
              全額信託保全
            </span>
            <span className="inline-flex items-center bg-white/15 backdrop-blur-sm text-white text-xs md:text-sm px-3 md:px-4 py-1.5 md:py-2 rounded-full">
              <i className="ri-lock-line text-teal-300 mr-1.5 md:mr-2 w-4 h-4 flex items-center justify-center"></i>
              最新セキュリティ
            </span>
            <span className="inline-flex items-center bg-white/15 backdrop-blur-sm text-white text-xs md:text-sm px-3 md:px-4 py-1.5 md:py-2 rounded-full">
              <i className="ri-customer-service-2-line text-teal-300 mr-1.5 md:mr-2 w-4 h-4 flex items-center justify-center"></i>
              24時間サポート
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}
